export default __webpack_public_path__ + "static/media/ParticleSuccess.170bdc76.jpg";